"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _ClientApplicationModal = _interopRequireDefault(require("@mulesoft/client-applications-ui/raw/components/ClientApplicationModal"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _utils = require("../../../common/components/RequestAccess/RequestAPIAccessModal/utils");
var _ResultModal = _interopRequireDefault(require("../../../common/components/RequestAccess/ResultModal"));
var _requestAccess = require("../../../common/store/requestAccess");
var _slaTiers = require("../../../common/store/slaTiers");
var apiGroupSelectors = _interopRequireWildcard(require("../../store/selectors"));
var _RequestAPIGroupAccessModal = _interopRequireDefault(require("./RequestAPIGroupAccessModal"));
var _modals = require("../../../common/utils/modals");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset;
  var masterOrganizationId = _exchangeUiPortalsStore.selectors.selectProfile(state).organization.id;
  var requestAccess = state.requestAccess;
  var managedInstances = apiGroupSelectors.apiGroupInstances(state, {
    filterDeprecated: true,
    groupId: asset.groupId,
    assetId: asset.assetId,
    versionGroup: asset.versionGroup
  });
  var hasUnderlyingTerms = apiGroupSelectors.hasUnderlyingTerms(state, {
    groupId: asset.groupId,
    assetId: asset.assetId,
    versionGroup: asset.versionGroup
  });
  var domain = _exchangeUiPortalsStore.selectors.selectPublicPortalDomain(state);
  return {
    asset: asset,
    domain: domain,
    hasUnderlyingTerms: hasUnderlyingTerms,
    managedInstances: managedInstances,
    masterOrganizationId: masterOrganizationId,
    currentApplication: requestAccess.currentApplication,
    isSubmiting: requestAccess.ui.isCreatingContract,
    errors: requestAccess.ui.errors
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var asset = _ref2.asset,
    context = _ref2.context,
    router = _ref2.router,
    config = _ref2.config,
    openModal = _ref2.openModal,
    pushModal = _ref2.pushModal;
  return {
    onCreateContract: function onCreateContract(params) {
      var openModalFn = function openModalFn() {
        openModal(_ResultModal.default, _objectSpread(_objectSpread({}, arguments.length <= 0 ? undefined : arguments[0]), {}, {
          assetType: 'api-group'
        }), arguments.length <= 1 ? undefined : arguments[1]);
      };
      dispatch(_requestAccess.actions.createContractForAPIGroup(params, router.getPath, openModalFn));
    },
    onCreateNewApplication: function onCreateNewApplication(providerId, instanceId, callback) {
      pushModal(_ClientApplicationModal.default, {
        assetType: asset.type,
        providerId: providerId,
        instanceId: instanceId,
        onError: function onError(error) {
          dispatch(_requestAccess.actions.createApplicationFailure(error));
        },
        onCreateApplication: callback
      });
      dispatch(_requestAccess.actions.resetModalState());
    },
    onLoadInstances: function onLoadInstances() {},
    loadApplications: function loadApplications(masterOrganizationId, apiGroupInstanceId) {
      return (0, _utils.getClientApplications)({
        context: context,
        masterOrganizationId: masterOrganizationId,
        apiGroupInstanceId: apiGroupInstanceId,
        config: config
      });
    },
    loadSLATiers: function loadSLATiers(params) {
      return dispatch(_slaTiers.actions.getAPIGroupSLATiers({
        groupId: asset.groupId,
        assetId: asset.assetId,
        versionGroup: asset.versionGroup,
        environmentId: params.instance.environmentId,
        apiGroupInstanceId: params.instance.id,
        domain: params.domain
      }));
    }
  };
};
var RequestAPIGroupAccessModalContainer = (0, _redux.compose)((0, _modals.setModalName)('RequestAPIGroupAccessModal'), _exchangeReactHooks.withModal, _exchangeReactHooks.withRouter, _exchangeReactHooks.withConfig, _exchangeReactHooks.withUserContext, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_RequestAPIGroupAccessModal.default);
var _default = exports.default = RequestAPIGroupAccessModalContainer;
//# sourceMappingURL=RequestAPIGroupAccessModal.container.js.map